// extracted by mini-css-extract-plugin
module.exports = {"settings":"styles_settings__2M-qO","toggle":"styles_toggle__1coTj","heading":"styles_heading__2aeO5","panel":"styles_panel__37lU0"};